import React from "react";

export default function InterdicaoToFields({
  Section,
  DropdownField,
  DateDropdownField,
  form,
  onChange,
  sbOptions,
  motivoOptions,
  motivoOptionsTo,
  nivelAcionamentoOptions,
  kmHint,
  kmError,
}) {
  const toMotivoOptions =
    Array.isArray(motivoOptionsTo) && motivoOptionsTo.length
      ?motivoOptionsTo
      : Array.isArray(motivoOptions)
        ?motivoOptions
        : [];

  return (
    <>
      <Section title="Operação">
        <div className="interdNova-grid interdNova-grid--3">
          <DateDropdownField
            label="Data"
            value={form.toData}
            onChange={onChange("toData")}
          />

          <label className="interdNova-field">
            <span>Horário início</span>
            <input
              type="time"
              value={form.toHorarioInicio}
              onChange={onChange("toHorarioInicio")}
            />
          </label>

          <DropdownField
            label="Seção de Bloqueio"
            value={form.toSb}
            onChange={onChange("toSb")}
            options={sbOptions}
            searchable
            searchInline
            preferredDirection="down"
            searchPlaceholder="Digite a seção de bloqueio"
            placeholder="Selecione a seção"
          />

          <label className="interdNova-field">
            <span>Km</span>
            <input
              type="text"
              className={kmError ?"interdNova-inputInvalid" : ""}
              value={form.toKm}
              onChange={onChange("toKm")}
              placeholder="125,300"
              aria-invalid={Boolean(kmError)}
            />
            {kmError ?(
              <small className="interdNova-fieldError">{kmError}</small>
            ) : kmHint ?(
              <small className="interdNova-fieldHint">{kmHint}</small>
            ) : null}
          </label>

          <label className="interdNova-field">
            <span>Ativo</span>
            <input
              type="text"
              value={form.toAtivo}
              onChange={onChange("toAtivo")}
              placeholder="Ex.: AT-001"
            />
          </label>

          <label className="interdNova-field">
            <span>Acionamento</span>
            <input
              type="text"
              value={form.toAcionamento}
              onChange={onChange("toAcionamento")}
              placeholder="Ex.: Solicitação operacional"
            />
          </label>

          <DropdownField
            label="Nível de Acionamento"
            value={form.toNivelAcionamento}
            onChange={onChange("toNivelAcionamento")}
            options={nivelAcionamentoOptions}
            placeholder="Selecione o nível"
            preferredDirection="down"
          />

          <DropdownField
            label="Motivo"
            value={form.toMotivo}
            onChange={onChange("toMotivo")}
            options={toMotivoOptions}
            placeholder="Selecione o motivo"
            searchable
            searchInline
            preferredDirection="down"
            searchPlaceholder="Digite o motivo"
            menuMaxHeight={164}
          />

          <label className="interdNova-field interdNova-field--full">
            <span>Obs.</span>
            <textarea
              rows="3"
              className="interdNova-observacao"
              value={form.toObservacao}
              onChange={onChange("toObservacao")}
              placeholder="Observações da interdição"
            />
          </label>
        </div>
      </Section>

      <Section title="Liberação">
        <div className="interdNova-grid interdNova-grid--3">
          <DropdownField
            label="Tem previsão?"
            value={form.toTemLiberacao}
            onChange={onChange("toTemLiberacao")}
            preferredDirection="up"
            options={[
              { value: "nao", label: "Não" },
              { value: "sim", label: "Sim" },
            ]}
          />

          {form.toTemLiberacao === "sim" ?(
            <>
              <DateDropdownField
                label="Data liberação"
                value={form.toDataLiberacao}
                onChange={onChange("toDataLiberacao")}
              />

              <label className="interdNova-field">
                <span>Horário liberação</span>
                <input
                  type="time"
                  value={form.toHorarioLiberacao}
                  onChange={onChange("toHorarioLiberacao")}
                />
              </label>
            </>
          ) : null}
        </div>
      </Section>
    </>
  );
}
